import store from 'store'

export const track = {
  click({ event = 'Click', ...rest }) {
    const user = store.state.user.data
    if (!window.dataLayer || user.isAdmin) return
    const userDetails = {
      user_id: user.id,
      user_role: user.role,
      startup_id: user.startupId,
      startup_name: user.startup ? user.startup.name : null,
    }
    window.dataLayer.push({ event, ...rest, ...userDetails })
  },
}
